import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import Card from '../../../Card';
import type { SearchAllContentArticleHit, SearchAllContentHit, SearchAllContentProjectHit } from '../../types';

type Type = Exclude<SearchAllContentHit, SearchAllContentArticleHit | SearchAllContentProjectHit>;

const SearchAllContentPageHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const { t } = useTranslation();

  const classes = classNames('SearchAllContentHit', 'SearchAllContentPageHit');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Link link={hit.url[0]}>
          <Card.Title title={<Highlight attribute="page_title" hit={hit} />} />
        </Card.Link>

        <div className="Card__content__metadata body--small">
          <Card.Tags
            tags={[{
              type: 'content_type',
              name: t(`content_types.${hit.content_type[0]}.type`),
            }]}
          />

          <span className="Card__content__url">
            ...{hit.url[0]}
          </span>
        </div>

        <Card.Subtitle
          subtitle={(
            <p className="u-truncate--3">
              {hit.body_summarized?.[0] ? (
                <Highlight attribute="body_summarized" hit={hit} />
              ) : (
                <Highlight attribute="body" hit={hit} />
              )}
            </p>
          )}
        />
      </Card.Content>
    </Card>
  );
};

export default SearchAllContentPageHit;
